import React, {memo} from 'react';
import Box from '@material-ui/core/Box';

import PlayrateWidget from '../../components/v2/sections/fortnite-games/playrate/PlayrateWidget';
import useGamesData from './useGamesData';

import {ChartContainer} from './FortniteGames.styles';

const Playrate = () => {
    const {
        data: {codeNamesMap, recentGamesOptions},
        loading: gamesLoading
    } = useGamesData();

    return (
        <Box marginTop={10}>
            <ChartContainer>
                <PlayrateWidget
                    selectedGames={recentGamesOptions.slice(0, 1)}
                    gamesList={recentGamesOptions}
                    keysMap={codeNamesMap}
                    gamesLoading={gamesLoading}
                />
            </ChartContainer>
        </Box>
    );
};

export default memo(Playrate);
